import { render, staticRenderFns } from "./RoleSelection.vue?vue&type=template&id=2ba678de&"
import script from "./RoleSelection.vue?vue&type=script&lang=ts&"
export * from "./RoleSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports